<template>
  <div>
    <h3 class="componentTitle">选择模板</h3>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-form-item label="喜报背景">
        <a-radio-group v-decorator="['bg']" @change="changeModel">
          <a-radio value="0">
            模板一
          </a-radio>
          <a-radio value="1">
            模板二
          </a-radio>
          <a-radio value="2">
            模板三
          </a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  components: {},
  props: {},
  data() {
    return {
      form: this.$form.createForm(this),
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.form.setFieldsValue({bg: '0',newsTitle: '随便生成一个喜报标题'})
  },
  methods: {
    ...mapMutations('news', ['setState']),
    // modelKey
    changeModel(e){
      this.setState({modelKey: e.target.value})
    },
  },
}
</script>
<style lang='scss'>

</style>
<style lang='scss' scoped></style>